var r=function(r,n,t){return n>=r&&n<=t};export{r as isInRange};
//# sourceMappingURL=isInRange.js.map
